import { ComponentProps, forwardRef } from 'react';

import { Box, Button, CSS, Typography } from '@project44/manifest-ds';

const styles = {
  button: {
    border: ' 1px solid $border-primary',
    justifyContent: 'flex-start',
    maxWidth: '',
    overflow: 'hidden',
    transition: 'width 1s',
    '&:hover': {
      backgroundColor: '$primary-hover',
    },
    '@media (max-width: 1328px)': {
      maxWidth: 42,
    },
  },
  count: {
    border: '1px solid white',
    overflow: 'hidden',
    backgroundColor: 'white',
    borderRadius: '$full',
    color: '$primary-active',
    height: '18px',
    minWidth: '18px',
    position: 'absolute',
    right: '-9px',
    textAlign: 'center',
    top: '-9px',
  },
  box: {
    backgroundColor: '$primary-hover',
    height: '100%',
    width: '100%',
  },
};

interface IHeaderButton extends Omit<ComponentProps<typeof Button>, 'variant'> {
  count?: number | boolean;
  css?: CSS;
  isActive?: boolean;
}

const HeaderButton = forwardRef<HTMLButtonElement, IHeaderButton>(
  ({ isActive = false, count, ...props }, ref) => (
    <Box css={{ position: 'relative' }}>
      <Button
        ref={ref}
        css={{
          ...styles.button,
          backgroundColor: isActive ? '$primary-default' : '$primary-active',
        }}
        {...props}
      />
      {!!count && (
        <Typography
          variant="captionBold"
          css={styles.count}
          children={count === true ? <Box css={styles.box} /> : count}
        />
      )}
    </Box>
  ),
);

export default HeaderButton;
